import { createElement, formatMoney, ObserveElement } from '../../../shared/helpers/DOMHelpers';
import { convertMS, difInMiliSeconds} from '../../../shared/helpers/DateHelpers';

export default class DiscountPresenter {
  constructor(settings, handle, discount ){
    this.discountKey = settings.discountKey;
    this.discountType = settings.discountType;

    this.handle = handle;
    this.discount = discount;

    this.setIntervalId = null;

    this.banner = document.querySelector('#announcement-timer-banner');
    this.bodyContainer = document.querySelector('.body-container');
    this.timers = document.querySelectorAll('.timer');
    this.subtotal = null;

  }

  async init(){
  }

  initializeBanner(timeStarted, discountTime) {
    this.manipulateBannertime(timeStarted, discountTime)
    this.setIntervalId = setInterval(() => {
      this.manipulateBannertime(timeStarted, discountTime);
    }, 1000);

    this.banner.setAttribute('style', 'display:flex');
    screen.width > 767 ? this.banner.classList.add('slideInUp') : this.banner.classList.add('slideInDown');
  }

  manipulateBannertime(timeStarted, discountTime){
    const time = convertMS(discountTime - difInMiliSeconds(timeStarted, Date.now()));
    if(time === "00 : 00 : 00") {
      this.banner.setAttribute('style', 'display:none');
      this.bodyContainer.setAttribute('style', `padding-top:0px`);
      FND.common.eventEmitter.emit('sale_is_over');
      clearInterval(this.setIntervalId); // Clear out the interval to cleanup
      return;
    }
    this.timers.forEach(timer => timer.textContent = time);

    const padding = this.banner.offsetHeight;
    this.bodyContainer.setAttribute('style', `padding-top:${padding}px`);
  }

  manipulatePricing() {

  }

  calculateDiscount(discountType, originalPrice, discount, quantity=1){
    if(discountType === 'flat'){
      return quantity * discount;
    }
    return quantity * originalPrice * discount;
  }

  updateSubtotal(subTotalPrice) {
    if(subTotalPrice){
      this.subtotal = subTotalPrice;
    }

    const cartSubTotalElem = document.querySelectorAll('[data-order-subtotal]');
    cartSubTotalElem.forEach(elem => {
      if(!elem){
        return;
      }
      setInterval(() => {
        elem.textContent = `${formatMoney(this.subtotal)}`;
      },500);
      if (false) { // Causes freeze on safari
      ObserveElement(elem, false, () => {
        elem.textContent = `${formatMoney(this.subtotal)}`;
      });
      }
      elem.textContent = `${formatMoney(this.subtotal)}`;
    });

  }
}